import React, { useEffect, useState } from 'react';
import { CourseDto, CourseDtoEx } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { SingleSelect } from '../../../../components/single-select';
import { ReadonlyInput } from '../../../../components/readonly-input';

const attendanceClient = moduleClientFactory.createAttendanceClient(true);

interface ICourseSelectorProps {
  isEditmode: boolean;
  courseId?: string;
  activityId?: string;
  onCourseChange: (course?: CourseDto) => void;
  error?: boolean;
  errorText?: string;
}

export function CourseSelector(props: ICourseSelectorProps) {
  const { isEditmode, courseId, activityId, onCourseChange, error, errorText } = props;
  const [courses, setCourses] = useState<CourseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadCourses();
  }, [activityId]);

  async function loadCourses() {
    try {
      setIsLoading(true);
      const response = await attendanceClient.getActiveCourses({ activityId });
      setCourses(response.courses || []);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }

  const selectedCourse = courses.find(x => x.courseId === courseId);

  if (isEditmode) {
    return <ReadonlyInput label="Hold" value={selectedCourse?.name} />;
  }

  return (
    <SingleSelect<CourseDtoEx>
      label="Hold"
      placeholder="Fremsøg hold"
      value={selectedCourse}
      options={courses}
      getOptionLabel={x => `${x.name} - ${x.companyName}${x.teamName ? ` - ${x.teamName}` : ''}`}
      renderOption={(prop: object, option: CourseDtoEx) => (
        <li {...prop} key={option.courseId}>
          {`${option.name} - ${option.companyName}${option.teamName ? ` - ${option.teamName}` : ''}`}
        </li>
      )}
      onChange={(value?: CourseDto) => onCourseChange(value)}
      variant="outlined"
      required
      error={error}
      errorText={errorText}
      loading={isLoading}
    />
  );
}
